import Vue from "vue"
import Router from "vue-router"
import index from "../pages/index"
import bind from "../pages/bind"
import order from "../pages/order"
import recharge from "../pages/recharge"
import login from "../pages/login"
import wxbind from "../pages/wxbind"
import feedback from "../pages/feedback"
import header from "../components/header"
import footer from "../components/footer"
import home from "../pages/home"
import kuaishouPage from "../pages/kuaishou/kuaishouPage"
import kuaishouPage1 from "../pages/kuaishou/kuaishouPage1"
import promotePage from "../pages/kuaishou/promotePage"
import promotePage01 from "../pages/kuaishou/promotePage01"
import promotePage03 from "../pages/kuaishou/promotePage03"
import change from "../pages/change"
import changeInfo from "../pages/changeInfo"
import device from "../pages/device.vue"
import customerCheck from "../pages/customer/check"
import customerCheckInfo from "../pages/customer/checkInfo"
import express from "../pages/express"
import productBind from "../pages/productBind";
import applyrecharge from "../pages/applyrecharge";
import expirenotice from "../pages/expirenotice";
import exchange from "../pages/exchange";
import changecode from "../pages/changecode";
import cardBalance from "../pages/cardbalance";
import rechargeBalance from "../pages/rechargeBalance";
import payticket from "../pages/payticket";
import devicelocal from "../pages/devicelocal.vue";
import tousujilu from "../pages/tousujilu.vue";
import usage from "../pages/usage.vue";
import authpage from "../pages/authpage.vue";
import shengji from "../pages/shengji.vue";
Vue.use(Router)
const routes = [
  {
    path: "/Tickets",
    name: "home",
    meta: {
      requireAuth: false
    },
    components: {
      default: payticket,
      header:header,
      footer:footer
    }
  },
    {
        path: "/home",
        name: "home",
        meta: {
            requireAuth: true
        },
        components: {
            default: index,
            header:header,
            footer:footer
        }
    },{
        path: "/authpage",
        name: "authpage",
        meta: {
            requireAuth: true
        },
        components: {
            default: authpage,
        }
    },{
        path: "/shengji",
        name: "shengji",
        meta: {
            requireAuth: true
        },
        components: {
            default: shengji,
        }
    },{
        path: "/device",
        name: "device",
        meta: {
            requireAuth: true
        },
        components: {
            default: device,
        }
    },{
        path: "/usage",
        name: "usage",
        meta: {
            requireAuth: true
        },
        components: {
            default: usage,
        }
    },{
        path: "/tousujilu",
        name: "tousujilu",
        meta: {
            requireAuth: true
        },
        components: {
            default: tousujilu,
        }
    },{
        path: "/devicelocal",
        name: "devicelocal",
        meta: {
            requireAuth: true
        },
        components: {
            default: devicelocal,
        }
    },{
        path: "/changecode",
        name: "changecode",
        meta: {
            requireAuth: true
        },
        components: {
            default: changecode,
        }
    },{
        path: "/applyrecharge",
        name: "applyrecharge",
        meta: {
            requireAuth: true
        },
        components: {
            default: applyrecharge,
            header:header,
            footer:footer
        }
    },{
        path: "/productBind",
        name: "productBind",
        components: {
            default: productBind,
        }
    },{
        path: "/exchange",
        name: "exchange",
    meta: {
      requireAuth: true
    },
        components: {
            default: exchange,
        }
    },{
        path: "/expirenotice",
        name: "expirenotice",
        components: {
            default: expirenotice,
        }
    },
    {
    path: "/cardbalance",
    name: "cardBalance",
      meta: {
        requireAuth: true
      },
    components: {
      default: cardBalance,
      header:header,
      footer:footer,
    }
  },
  {
    path: "/rechargeBalance",
    name: "rechargeBalance",
    meta: {
      requireAuth: true
    },
    components: {
      default: rechargeBalance,
      header:header,
      footer:footer,
    }
  },
    {
        path: "/",
        name: "bind",
        meta: {
            requireAuth: false
        },
        components: {
            default: bind,
            header:header,
            footer:footer
        }
    },{
        path: "/bind",
        name: "bind",
        meta: {
            requireAuth: false
        },
        components: {
            default: bind,
            header:header,
            footer:footer
        }
    },
    {
        path: "/order",
        name: "order",
        meta: {
            requireAuth: true
        },
        components: {
            default: order,
            header:header,
            footer:footer
        }
    },
    {
        path: "/recharge",
        name: "recharge",
        meta: {
            requireAuth: true
        },
        components: {
            default: recharge,
            header:header,
            footer:footer
        }
    },
    {
        path: "/login",
        name: "login",
        meta: {
            requireAuth: false
        },
        components: {
            default: login
        }
    },
    {
        path: "/wxbind",
        name: "wxbind",
        meta: {
            requireAuth: false
        },
        components: {
            default: wxbind
        }
    },
    {
        path: "/kuaishouPage",
        name: "kuaishouPage",
        meta: {
            requireAuth: false
        },
        components: {
            default: kuaishouPage
        }
    },{
        path: "/promotePage",
        name: "promotePage",
        meta: {
            requireAuth: false
        },
        components: {
            default: promotePage
        }
    },{
        path: "/promotePage01",
        name: "promotePage01",
        meta: {
            requireAuth: false
        },
        components: {
            default: promotePage01
        }
    },{
        path: "/promotePage03",
        name: "promotePage03",
        meta: {
            requireAuth: false
        },
        components: {
            default: promotePage03
        }
    },{
        path: "/kuaishouPage1",
        name: "kuaishouPage1",
        meta: {
            requireAuth: false
        },
        components: {
            default: kuaishouPage1
        }
    },
    {
        path: "/feedback",
        name: "feedback",
        meta: {
            requireAuth: false
        },
        components: {
            default: feedback,
            header:header,
            footer:footer
        }
    },
    {
        path: "/index",
        name: "index",
        meta: {
            requireAuth: true
        },
        components: {
            default: index,
            header:header,
            footer:footer
        }
    },
    {
        path: "/customerCheck",
        name: "customerCheck",
        components: {
            default: customerCheck,
            header:header,
            footer:footer
        }
    },
    {
        path: "/customerCheckInfo",
        name: "customerCheckInfo",
        components: {
            default: customerCheckInfo,
            header:header,
            footer:footer
        }
    },
    {
        path: "/change",
        name: "change",
        components: {
            default: change,
            header:header,
            footer:footer
        }
    },
    {
        path: "/changeInfo",
        name: "changeInfo",
        components: {
            default: changeInfo,
            header:header,
            footer:footer
        }
    },{
        path: "/express",
        name: "express",
        components: {
            default: express,
            header:header,
            footer:footer
        }
    },
]
const router = new Router({
    routes
})
router.beforeEach((to, from, next) => {
    let href = location.href;
    if (href.includes("//wxbind")) {
        let url = href.substring(0, href.indexOf('#'));
        let jingPosit = url.indexOf("//wxbind"); //获取域名结束的位置
        let urlLeft = url.substring(0, jingPosit);//url左侧部分
        let urlRight = url.substring(jingPosit+1, url.length); //url右侧部分
        let redirect = urlLeft+"/#" + urlRight;
        location.href = redirect//拼接跳转
    }
  console.log(href)
  if (href.includes("//login")) {
    let url = href.substring(0, href.indexOf('#'));
    let jingPosit = url.indexOf("//login"); //获取域名结束的位置
    let urlLeft = url.substring(0, jingPosit);//url左侧部分
    let urlRight = url.substring(jingPosit+1, url.length); //url右侧部分
    let redirect = urlLeft+"/#" + urlRight;
    location.href = redirect//拼接跳转
  }
    if (to.meta.requireAuth && !sessionStorage.getItem('token')) {
        let query = to.query;
        query.path = to.path
        next({
            path: 'login',
            query:query
        })
    }else{
        next();
    }
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js